import { useQuery } from "@tanstack/react-query";

import type { IWebsiteAnalysisTrafficRequestParams } from "app/pages/website-analysis/TrafficAndEngagement/types";
import WebsiteAnalysisApiService from "app/services/WebsiteAnalysis/WebsitAnalysisApiService";

/* eslint-disable @typescript-eslint/naming-convention */
export interface IMonthlyActiveUsersResponse {
    Data: Record<
        string,
        {
            AverageTotalVisitsMonthly: number;
            AverageUniqueVisitorsMonthly: number;
            VisitsPerUser: number;
            HasGaToken: boolean;
            Trend: number[];
            Change: number;
        }
    >;
    KeysDataVerification?: Record<string, boolean>;
}
/* eslint-enable @typescript-eslint/naming-convention */

export const useMonthlyActiveUsersData = (
    params: IWebsiteAnalysisTrafficRequestParams,
    { enabled = true }: { enabled?: boolean } = {},
) => {
    return useQuery<IMonthlyActiveUsersResponse>({
        queryKey: ["monthlyActiveUsers", params],
        queryFn: () => WebsiteAnalysisApiService.getInstance().getUniqueAndTotalVisitsMonthly(params),
        enabled,
    });
};
